import $ from "jquery";
import { isPC } from "./ua";


export default class SPMenu {
  constructor() {}

  init() {
    if (isPC()) {
      return;
    }

    const $menuToggle = $("#menu-toggle");
    const $menuWrapper = $("#js-menu-wrapper");
    const $menu = $("#js-menu");
    const $menuItem = $menu.find(".menu__item");

    $menuItem.click(() => {
      setTimeout(() => {
        $menuWrapper.fadeOut();
        $menu.removeClass("show");
        $menu.addClass("hidden");
        $menuItem.removeClass("show");
        $menuItem.addClass("hidden");

        $("#menu-toggle").prop("checked", false);
      }, 60);
    });

    $menuToggle.change((e) => {
      if ($(e.target).is(":checked")) {
        $menuWrapper.fadeIn(() => {
          $menu.removeClass("hidden");
          $menu.addClass("show");
          $menuItem.removeClass("hidden");
          $menuItem.addClass("show");
        });

      } else {
        $menu.removeClass("show");
        $menu.addClass("hidden");
        $menuItem.removeClass("show");
        $menuItem.addClass("hidden");

        setTimeout(() => {
          $menuWrapper.fadeOut();
        }, 500);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/SPMenu.js